__webpack_require__.p = "https://kadry.vchasno.ua/cloud-cgi/static/hrs-static-files-prd/";